import React from 'react';
import toast from 'react-hot-toast';
import { CircleCrossLined, CircleInfoLined, CrossFilled, WarningFilled } from '@tag/tag-icons';
import cn from 'classnames';

import styles from './toast.module.scss';

enum ToastType {
  danger = 'danger',
  success = 'success',
  warning = 'warning',
}

export interface ICustomToastProps {
  id: string;
  title: string;
  text: string;
  // keyof typeof for backword compatibility with inion type
  type: keyof typeof ToastType;
  closeable?: boolean;
}

const icons = {
  danger: <CircleCrossLined accent="white" />,
  success: <CircleInfoLined accent="white" />,
  warning: <WarningFilled accent="white" />
};

export default function CustomToast({
  id,
  title,
  text,
  type,
  closeable = true,
}: ICustomToastProps) {
  const onClick = () => {
    toast.remove(id);
  };

  const toastType = ToastType[type];

  return (
    <div className={cn(styles.toast, styles[toastType])}>
      <div className={styles['icon-wrapper']}>
        {icons[type]}
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.text}>{text}</div>
      </div>

      {closeable && (
        <div className={styles['button-wrapper']}>
          <button
            className={styles.button}
            type="button"
            onClick={onClick}
          >
            <CrossFilled
              accent="white"
            />
          </button>
        </div>
      )}
    </div>
  );
}
